export const grey = '#777';
export const black = '#333';
export const darkBlack = '#000';
export const white = '#FFF'